import React from 'react';
import Modal from 'react-modal';
import { Translate } from '../../../core/translate';
import {
  ButtonText,
  PrimaryButton,
  SecondaryButton
} from '../../../core/controls';

const WarningHeader = props => {
  const { title, onClose } = props;

  return (
    <div className="modal-header">
      <div className="modal-header__title">{title}</div>
      <button className="modal-header__close" onClick={onClose}>
        <svg className="svg-icon--close svg-icon" viewBox="0 0 19.41 19.41">
          <path strokeWidth="2px" d="M.71.71l18 18M18.71.71l-18 18" />
        </svg>
      </button>
    </div>
  );
};

const WarningFooter = ({ vsUrl, onClose }) => {
  return (
    <div className="modal-footer">
      <div className="modal-footer__inner">
        <div className="modal-footer__buttons modal-footer__buttons--inline">
          <SecondaryButton onClick={onClose}>
            <ButtonText>
              <Translate value="byo.page.general.cancel" />
            </ButtonText>
          </SecondaryButton>
          <PrimaryButton as="a" href={vsUrl}>
            <ButtonText>
              <Translate value="byo.page.general.ok" />
            </ButtonText>
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

const WarningModal = props => {
  const { isOpen, onWarningModalClose, vsUrl } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onWarningModalClose}
      className="modal"
      overlayClassName="overlay">
      <WarningHeader title="" onClose={onWarningModalClose} />
      <div className="modal-body">
        <div className="modal-body__inner">
          {' '}
          <Translate value="model.selector.inventory.disclaimer" />
        </div>
      </div>
      <WarningFooter vsUrl={vsUrl} onClose={onWarningModalClose} />
    </Modal>
  );
};

export default WarningModal;
